import {PRIMARY_CHAIN} from '@/util/chains';

export enum ChainId {
  Mainnet = 1,
  Sepolia = 11155111,
  Base = 8453,
  Polygon = 137,
  BSC = 56,
  PolygonMumbai = 80001,
  ArbitrumOne = 42161,
  Optimism = 10,
  ArbitrumSepolia = 421614,
}

export const TestnetChains = [ChainId.Sepolia, ChainId.ArbitrumSepolia];
export const MainnetChains = Object.values(ChainId).filter(
  chainId =>
    !TestnetChains.includes(chainId as ChainId) && typeof chainId === 'number'
) as ChainId[];

export const ChainNames: Record<ChainId, string> = {
  [ChainId.Mainnet]: 'Ethereum Mainnet',
  [ChainId.Sepolia]: 'Sepolia',
  [ChainId.Base]: 'Base',
  [ChainId.Polygon]: 'Polygon',
  [ChainId.BSC]: 'Binance Smart Chain',
  [ChainId.PolygonMumbai]: 'Polygon Mumbai',
  [ChainId.ArbitrumOne]: 'Arbitrum One',
  [ChainId.Optimism]: 'Optimism',
  [ChainId.ArbitrumSepolia]: 'Arbitrum Sepolia',
};

export const ChainImages: Record<ChainId, string> = {
  [ChainId.Mainnet]:
    'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  [ChainId.Sepolia]:
    'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  [ChainId.Base]:
    'https://assets.coingecko.com/asset_platforms/images/131/small/base-network.png',
  [ChainId.Polygon]:
    'https://assets.coingecko.com/coins/images/4713/small/polygon.png',
  [ChainId.BSC]:
    'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  [ChainId.PolygonMumbai]:
    'https://assets.coingecko.com/coins/images/4713/small/polygon.png',
  [ChainId.ArbitrumOne]:
    'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg',
  [ChainId.Optimism]:
    'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  [ChainId.ArbitrumSepolia]:
    'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg',
};

export const AvailableChains = TestnetChains.includes(PRIMARY_CHAIN)
  ? TestnetChains
  : MainnetChains;

export const usdtContract: Partial<Record<ChainId, string>> = {
  [ChainId.Mainnet]: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  [ChainId.Polygon]: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
  [ChainId.ArbitrumOne]: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  [ChainId.ArbitrumSepolia]: '0xE742da76701dc9BB348EB931959DD42B9DF04Ff6', // TODO unknown
  [ChainId.PolygonMumbai]: '0xeaBc4b91d9375796AA4F69cC764A4aB509080A58',
  [ChainId.Optimism]: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
};

export const usdcContract: Partial<Record<ChainId, string>> = {
  [ChainId.Mainnet]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  [ChainId.Polygon]: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
  [ChainId.PolygonMumbai]: '0x0fa8781a83e46826621b3bc094ea2a0212e71b23',
  [ChainId.ArbitrumOne]: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
  [ChainId.ArbitrumSepolia]: '0xfd064a18f3bf249cf1f87fc203e90d8f650f2d63',
  [ChainId.Optimism]: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
};

export const daiContract: Partial<Record<ChainId, string>> = {
  [ChainId.Mainnet]: '0x6b175474e89094c44da98b954eedeac495271d0f',
  [ChainId.Polygon]: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
  [ChainId.PolygonMumbai]: '0xd393b1E02dA9831Ff419e22eA105aAe4c47E1253',
  [ChainId.ArbitrumOne]: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
  [ChainId.Optimism]: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
};

export const maticContract: Partial<Record<ChainId, string>> = {
  [ChainId.Mainnet]: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
  [ChainId.Polygon]: '0x0000000000000000000000000000000000001010',
  [ChainId.PolygonMumbai]: '0x0000000000000000000000000000000000001010',
  [ChainId.ArbitrumOne]: '0x561877b6b3DD7651313794e5F2894B2F18bE0766',
  [ChainId.Optimism]: '0xe211233fE8b6964208CfC7CA66df9C0340088670',
};

export const wBTCContract: Partial<Record<ChainId, string>> = {
  [ChainId.Mainnet]: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
  [ChainId.Polygon]: '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6',
  [ChainId.PolygonMumbai]: '0x0d787a4a1548f673ed375445535a6c7A1EE56180',
  [ChainId.ArbitrumOne]: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
  [ChainId.Optimism]: '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
};

export const CONTRACTS_ADDRESS_MAP: Record<
  string,
  Partial<Record<ChainId, string>>
> = {
  BTC: wBTCContract,
  DAI: daiContract,
  MATIC: maticContract,
  USDC: usdcContract,
  USDT: usdtContract,
};
